import React from 'react'
import { useTranslation } from 'react-i18next'
import Contatos from '../components/Contatos'
import Created from '../components/Created'
import Header from '../components/Header'
import Sobre from '../components/Sobre'
import Tecnologias from '../components/Tecnologias'


export default function HomePage() {
    const { t } = useTranslation();
    return (
        <div>
            <div>
                <Header
                    langSwitcher
                    tecnologias={t('nav.tecnologias')}
                    contatos={t('nav.contatos')}
                    appsBackEnd={t('nav.projetos')}
                />
            </div> 
            <div> 
                <Sobre />
            </div>
            <div>
                <Header contatos={t('nav.meusContatos')}/>
                <Contatos />
            </div>
            <div>
                <Header tecnologias={t('nav.minhasEspecialidades')}/>
                <Tecnologias />
            </div>
            <div>
                <Created />
            </div>
        </div>
    )
}
